/** @jsxImportSource @emotion/react */
import {
  NumberInput,
  NumberInputField,
  Slider,
  SliderFilledTrack,
  SliderThumb,
  SliderTrack,
} from "@chakra-ui/react";
import styled from "@emotion/styled";
import React, { useEffect, useState } from "react";
import useDebounce from "../../utils/UseDebounce";

const Wrapper = styled.div`
  /* margin-bottom: 30px; */
`;

const Label = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0px;
  color: #333333;
  margin-bottom: 8px;
`;

const Range = styled.div`
  width: 100%;
  padding: 0px 10px;
`;

interface Props {
  value: number;
  handleValueChange: (vle: string) => void;
  label: string;
  max: number;
  min: number;
}

export default function FormInputRange(props: Props) {
  const debouncedValue = useDebounce(props.value, 400);
  const [inputValue, setInputValue] = useState(props.value);
  const [rangeValue, setRangeValue] = useState(props.value);

  useEffect(() => {
    let newValue = props.value;
    if (newValue < props.min) {
      newValue = props.min;
      props.handleValueChange(`${props.min}`);
    }

    setInputValue(newValue);
    setRangeValue(newValue);
  }, [debouncedValue]);

  return (
    <>
      <Label>
        {props.label}
        <NumberInput
          w={props.max < 1000 ? "75px" : "85px"}
          value={inputValue}
          onChange={(vle) => {
            let value = vle;
            if (parseInt(value) > props.max) value = `${props.max}`;
            props.handleValueChange(value);
            setInputValue(+value);
          }}
        >
          <NumberInputField _focus={{ borderColor: "orange.50" }} />
          {/* <NumberInputStepper>
            <NumberIncrementStepper />
            <NumberDecrementStepper />
          </NumberInputStepper> */}
        </NumberInput>
      </Label>
      <Range>
        <Slider
          value={rangeValue}
          aria-label="slider"
          max={props.max || 100}
          min={props.min || 0}
          onChange={(vle) => {
            props.handleValueChange(`${vle}`);
            setRangeValue(vle);
          }}
        >
          <SliderTrack h="10px" borderRadius="8px" bg="#EEEEEE">
            <SliderFilledTrack bg="orange.50" />
          </SliderTrack>
          <SliderThumb
            bg="orange.50"
            h="20px"
            w="20px"
            _focus={{ outline: "none" }}
          />
        </Slider>
      </Range>
    </>
  );
}
